import React from "react";
import { Formik, Form, Field } from 'formik';
import PaginationFooter from "helpers/PaginationFooter";
import moment from "moment";

function ListView({
  formRef,
  companies = [],
  devices = [],
  commands = [],
  isLoading,
  page,
  totalPages,
  setSelectedCompany,
  setSelectedDevice,
  setPage,
  onSubmit = () => { },
}) {
  return (
    <div className=''>
      <Formik
        innerRef={formRef}
        initialValues={{}}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, resetForm }) =>
          <Form>

            <div class="mb-3">
              <div class="form-group">
                <label class="input">
                  <select
                    class="form-control input__field"
                    placeholder=" "
                    onChange={(e) => {
                      setSelectedCompany(companies.find(company => company.id == e.target.value));
                    }}
                  >
                    <option value="">Selecciona un ambiente</option>
                    {
                      companies.map((company) => (
                        <option key={company.id} value={company.id}>{company.key} - {company.name}</option>
                      ))
                    }
                  </select>
                  <span class="input__label">Ambiente</span>
                </label>
              </div>
            </div>

            <div class="mb-3">
              <div class="form-group">
                <label class="input">
                  <select
                    class="form-control input__field"
                    placeholder=" "
                    onChange={(e) => {
                      setFieldValue('device.id', e.target.value);
                      setSelectedDevice(devices.find(device => device.id == e.target.value));
                    }}
                  >
                    <option value="">Selecciona un lector</option>
                    {
                      devices.map((device) => (
                        <option key={device.id} value={device.id}>{device.serial_number} - {device.model} ({device.description})</option>
                      ))
                    }
                  </select>
                  <span class="input__label">Lector</span>
                </label>
              </div>
            </div>

            <div class="mb-3">
              <div class="form-group">
                <label class="input">
                  <Field
                    as="select"
                    name="type" 
                    class="form-control input__field" 
                    placeholder=" " 
                    value={values.type ? values.type : ''}
                    onChange={(e) => {
                      setFieldValue('type', e.target.value);
                      if (e.target.value !== 'raw_command') {
                        setFieldValue('raw_command', null);
                      }
                    }}
                  >
                    <option value="">Selecciona un comando</option>
                    <option value="reboot">Reiniciar</option>
                    <option value="get_attendance">Recuperar marcajes</option>
                    <option value="delete_users">Borrar usuarios</option>
                    <option value="delete_photos">Borrar rostros</option>
                    <option value="delete_fp">Borrar huellas</option>
                    <option value="delete_attendance">Borrar marcajes</option>
                    <option value="raw_command">Comando personalizado</option>
                  </Field>
                  <span class="input__label">Tipo de comando</span>
                </label>
              </div>
            </div>

            {
              values.type == "get_attendance" && <>
                <div class="mb-3">
                  <div class="form-group">
                    <label class="input">
                      <Field
                        type="date"
                        name="start_date" 
                        class="form-control input__field" 
                        placeholder=" " 
                        value={values.start_date ? values.start_date : ''}
                      />
                      <span class="input__label">Fecha de inicio</span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="form-group">
                    <label class="input">
                      <Field
                        type="date"
                        name="end_date" 
                        class="form-control input__field" 
                        placeholder=" " 
                        value={values.end_date ? values.end_date : ''}
                      />
                      <span class="input__label">Fecha de fin</span>
                    </label>
                  </div>
                </div>
              </>
            }

            {
              values.type === 'raw_command' && 
                <div class="mb-3">
                  <div class="form-group">
                    <label class="input">
                      <Field
                        type="text"
                        name="raw_command" 
                        class="form-control input__field" 
                        placeholder=" " 
                        value={values.raw_command ? values.raw_command : ''}
                      />
                      <span class="input__label">Comando</span>
                    </label>
                  </div>
                </div>
            }

            <div class="mb-3">
              <button type="submit" class="btn w-100 btn-primary">Enviar</button>
            </div>

          </Form>
        }
      </Formik>

      {
        isLoading 
          ? <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          : <table className="table table-sm table-striped table-bordered">
              <thead>
                <tr>
                  <th className="w-10">ID</th>
                  <th className="w-50">Comando</th>
                  <th>Estado</th>
                  <th>Fecha de creación</th>
                  <th>Fecha de respuesta</th>
                </tr>
              </thead>
              <tbody>
                {
                  commands.map((command) => (
                    <tr key={command.id}>
                      <td>{command.id}</td>
                      <td className="text-break">{command.content?.substring(0, 90)}...</td>
                      <td>{command.response == "OK" ? 'OK' : 'N/A'}</td>
                      <td>{moment(command.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                      <td>{command.response_time ? moment(command.response_time).format('DD/MM/YYYY HH:mm') : 'N/A'}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
      }

      <PaginationFooter
        pageNum={page}
        totalPages={totalPages}
        onClickPage={setPage}
      />

    </div>
  );
}

export default ListView;